import React, { useState } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { retryXeroAddressSync } from '../services/api';

// Shown when a saved address could not be pushed to the linked Xero contact.
export const XeroAddressSyncBanner = ({ kind, doc, onDone }) => {
  const [busy, setBusy] = useState(false);
  const state = doc?.xeroAddressSync;
  if (!doc?.xeroContactId || state?.status !== 'failed') return null;
  const retry = async () => {
    setBusy(true);
    try {
      const r = await retryXeroAddressSync(kind, doc.id);
      if (r.status === 'ok') toast.success('Address updated in Xero');
      else toast.error(`Xero still not updated: ${r.error || r.reason}`);
      onDone?.(r);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Retry failed');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="xero-address-sync-banner">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-[12rem]">
        Address saved in Lutrom but not yet updated in Xero: {state.error}
      </span>
      <Button size="sm" variant="outline" onClick={retry} disabled={busy} data-testid="xero-address-sync-retry">
        <RefreshCw className={`h-3.5 w-3.5 mr-1.5 ${busy ? 'animate-spin' : ''}`} /> Retry Xero update
      </Button>
    </div>
  );
};

export default XeroAddressSyncBanner;
